var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "nav-fade", appear: "" } },
    [
      _vm.flags.isOpen
        ? _c(
            "v-container",
            {
              ref: "scrollContainer",
              staticClass: "snb overflower",
              attrs: { fluid: "" },
              on: {
                scroll: _vm.handleScroll,
                mouseenter: _vm.handleMouseEnter,
                mouseleave: _vm.handleMouseLeave,
              },
            },
            [
              _c(
                "v-container",
                { staticClass: "snb__inner" },
                [
                  _c(
                    "div",
                    { staticClass: "snb__tabs" },
                    [
                      _vm._l(_vm.sitemaps, function (sitemap, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            staticClass: "snb__tab-btn",
                            class: {
                              "is-active":
                                _vm.states.activeSectionIndex === index,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setActiveSection(index)
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(sitemap.SECTION.NAME))])]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "snb__tab-btn snb__search-btn",
                          class: { "is-active": _vm.flags.isSearching },
                          on: { click: _vm.toggleSearch },
                        },
                        [
                          _c("v-icon", { attrs: { size: 20 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.flags.isSearching
                                  ? "mdi-close"
                                  : "mdi-magnify"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "search-slide" } }, [
                        _vm.flags.isSearching
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.states.searchQuery,
                                  expression: "states.searchQuery",
                                },
                              ],
                              ref: "searchInput",
                              staticClass: "snb__search-input",
                              attrs: { type: "text", placeholder: "..." },
                              domProps: { value: _vm.states.searchQuery },
                              on: {
                                focus: function ($event) {
                                  _vm.flags.isSearchFocused = true
                                },
                                blur: function ($event) {
                                  _vm.flags.isSearchFocused = false
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.states,
                                    "searchQuery",
                                    $event.target.value
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _vm.activeSitemap
                        ? _c(
                            "v-col",
                            {
                              staticClass: "snb__content",
                              attrs: { cols: "12" },
                            },
                            [
                              _vm.filteredGroups.length
                                ? _c(
                                    "div",
                                    { staticClass: "snb__groups" },
                                    _vm._l(
                                      _vm.filteredGroups,
                                      function (groupData, gIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key: gIndex,
                                            staticClass: "snb__group",
                                          },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass: "snb__group-title",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      groupData.GROUP
                                                        .SHORTNAME ||
                                                        groupData.GROUP.NAME
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "snb__group-tabs",
                                              },
                                              _vm._l(
                                                groupData.TABS,
                                                function (tab, tIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: tIndex,
                                                      staticClass: "snb__tab",
                                                    },
                                                    [
                                                      tab.TYPE === "tab"
                                                        ? _c(
                                                            "h4",
                                                            {
                                                              staticClass:
                                                                "snb__tab-title",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    tab.NAME
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "ul",
                                                        {
                                                          staticClass:
                                                            "snb__items",
                                                        },
                                                        _vm._l(
                                                          tab.ITEMS,
                                                          function (
                                                            item,
                                                            iIndex
                                                          ) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                key: iIndex,
                                                                staticClass:
                                                                  "snb__item",
                                                              },
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: item.LINK,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.NAME
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "snb__search-empty" },
                                    [_c("span", [_vm._v("검색 결과가 없어요")])]
                                  ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "snb__scroll-anchor" },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.flags.canScroll &&
                                  !_vm.flags.isScrolledToBottom,
                                expression:
                                  "flags.canScroll && !flags.isScrolledToBottom",
                              },
                            ],
                            staticClass: "snb__scroll-btn",
                            on: { click: _vm.scrollToBottom },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 24 24",
                                  width: "24",
                                  height: "24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }